<div *ngIf="appUpdateAvailable" class="app-notice">
  <span class="ciap-icon icon-lightning"></span>A new version of CIAP Application is available.
  <a href="#" class="btn-link" (click)="activateUpdate()">Click here</a> to reload to apply new changes.
  <button (click)="closeUpdateNotification()" class="ml-2 mb-1 close" type="button close-btn">
    <span class="icon-Close"></span>
  </button>
</div>

<div class="component-wrapper">
  <div class="body-wrapper">
    <router-outlet></router-outlet>
  </div>

  <ng-container
    *showIfHasFeature="{ feature: 'overlay.chatbot-bayer', hiddenIf: 'overlay.chatbot', hideIfMissing: true }"
  >
    <!-- Commented in UP -->
    <!-- <ng-container *ngIf="isAuthenticated">
      <div class="chat-bot-activation-btn" *ngIf="!isbotVisible">
        <div (click)="showChatBot()">
          <img src="assets/images/icons/bubble-dots.png" />
        </div>
      </div>
      <app-bayer-chatbot
        [botVisible]="isbotVisible"
        (hideChatbot)="toogleChatBot($event)"
        (reloadChatbot)="refreshChatBot($event)"
        *ngIf="isbotVisible"
      ></app-bayer-chatbot>
    </ng-container> -->
  </ng-container>

  <ng-container
    *showIfHasFeature="{ feature: 'overlay.chatbot', hiddenIf: 'overlay.chatbot-bayer', hideIfMissing: true }"
  >
    <!-- Commented in UP -->
    <!-- <ng-container *ngIf="isAuthenticated">
      <div class="chat-bot-activation-btn" *ngIf="!isbotVisible">
        <div (click)="showChatBot()">
          <img src="assets/images/icons/bubble-dots.png" />
        </div>
      </div>
      <app-ciap-chatbot
        [botVisible]="isbotVisible"
        (hideChatbot)="toogleChatBot($event)"
        (reloadChatbot)="refreshChatBot($event)"
        *ngIf="isbotVisible"
      ></app-ciap-chatbot>
    </ng-container> -->
  </ng-container>
  <app-footer *ngIf="isAuthenticated" [isAuthenticated]="isAuthenticated"></app-footer>
</div>

<app-toasts-container aria-atomic="true" aria-live="polite"></app-toasts-container>

<app-loader *ngIf="isLoaderShowing" class="overlay"></app-loader>
